import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createBlock(_component_van_button, {
    class: "clipboard-btn",
    "data-clipboard-text": $props.value
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, () => [_createTextVNode("复制")])]),
    _: 3
  }, 8, ["data-clipboard-text"]);
}